<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="{ 'record-single-comment': true, 'record-single-comment-reserve': reserve }">
    <div class="record-single-box">
      <div class="record-comment-date">
        <span>{{ parseDate }}</span>
      </div>
      <div class="record-comment-comment-main">
        <div class="record-comment-avatar">
          <person-avatar
            :avatarUrl="commentator.headPortrait"
            :personName="commentator.username"
            defaultAvatarColor="#027AFF"
            class="single-record-commentator"
          ></person-avatar>
          <div class="record-commentator-name">
            {{ commentator.username }}
          </div>
        </div>
        <div class="record-comment-container">
          <div class="record-comment-info">
            <div class="record-comment-state">
              <cube-button v-if="content.sending" circle :loading="true"></cube-button>
              <cube-button
                v-else-if="content.error"
                circle
                icon="cubeic-warn"
                @click="retry"
              ></cube-button>
            </div>
          </div>
          <div class="record-comment-content">
            <div class="record-comment-text" v-html="content.content"></div>
            <div v-if="content.content && content.attachments && content.attachments.length > 0"
                 class="record-comment-spliter"></div>
            <div class="single-comment-attachments">
              <template v-for="item in attachments">
                <cube-button
                  :key="item.id"
                  type="text"
                  class="single-comment-attachment"
                  @click="handleAttachmentClick(item)"
                >
                  {{ item.fileName }}
                </cube-button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PersonAvatar from '@/components/x-avatar/x-avatar'
import { mapState } from 'vuex'

export default {
  components: {
    PersonAvatar
  },
  props: {
    content: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo,
      token: state => state.authModule.token,
      currentOrg: (state) => state.tenantModule.currentOrg
    }),
    commentator() {
      return this.content.commenter || {}
    },
    parseDate() {
      return this.content && this.content.creationDate.substr(0, 16)
    },
    reserve() {
      return this.userInfo.id === this.commentator.id
    },
    attachments() {
      return this.content.attachments || []
    }
  },
  mounted() {
    this.checkMentions()
  },
  methods: {
    retry() {
      this.$emit('retry', this.content)
    },
    checkMentions() {
      const usersMap = this.content.usersMap
      if (usersMap && Object.keys(usersMap).length > 0) {
        let flag = false
        const tmp = document.createElement('div')
        tmp.innerHTML = this.content.content
        console.log(tmp.innerHTML)
        const mentions = tmp.querySelectorAll('span.editor-comment-mention')
        Array.prototype.slice.call(mentions).forEach((ele) => {
          const id = ele.attributes['data-mention-id'].value
          const name = ele.innerText.substring(1)
          if (usersMap[id] && usersMap[id].username !== name) {
            ele.innerText = '@' + usersMap[id].username
            flag = true
          }
        })
        if (flag) {
          this.content.content = tmp.innerHTML
        }
      }
    },
    handleAttachmentClick(att) {
      const params = this.$base64.encode(
        JSON.stringify({
          xdaptenantid: this.currentOrg.id,
          xdaptoken: this.token
        })
      )
      const downloadUrl = att.url + '&token=' + params
      window.open(downloadUrl + '&download=download', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .record-single-comment {
    position: relative;
    display: flex;
    word-break: break-all;
    word-wrap: break-word;

    .record-single-box {
      display: block;
      width: 100%;

      .record-comment-date {
        margin: 0 auto;
        color: $--app-notice-color;
        text-align: center;
        font-size: 12px;

        span {
          display: inline-block;
          border-radius: 12px;
          padding: 0 8px;
          line-height: 14px;
          background-color: $--app-light-color;
        }
      }

      .record-comment-comment-main {
        background-color: $--app-light-color;
        box-sizing: border-box;
        padding: 12px;
        margin: 12px 0;
        font-size: 14px;

        .record-comment-container {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          .record-comment-info {
            color: $--app-notice-color;
            display: flex;
            height: 12px;
            position: absolute;
            top: 30px;
            right: 14px;
            .record-comment-state {
              .cube-btn {
                height: 2.29rem;
                padding: 0;
                font-size: 2rem;
                background-color: transparent!important;
                color: $--app-primary-color;
              }
            }
          }

          .record-comment-content {
            border: 1px solid $--app-box-shadow;
            padding: 6px 0;
            position: relative;
            background-color: $--app-light-color;

            &::before {
              position: absolute;
              content: '';
              border-bottom: 8px solid transparent;
              border-top: 8px solid $--app-box-shadow;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              left: -8px;
              top: -1px;
            }

            &::after {
              position: absolute;
              content: '';
              border-bottom: 8px solid transparent;
              border-top: 8px solid $--app-light-color;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              left: -6px;
              top: 0px;
            }

            .record-comment-spliter {
              height: 8px;
            }

            .single-comment-attachments {
              height: auto;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              .cube-btn {
                line-height: 16px;
              }
              .single-comment-attachment {
                & + .single-comment-attachment {
                  margin-top: 8px;
                }

                width: auto;
                padding: 0 !important;
                height: auto;
                text-align: left;
                margin-left: 0;
                color: $--app-primary-color;
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }

  .record-single-comment-reserve {
    flex-direction: row-reverse;

    .record-comment-container {
      align-items: flex-end;

      .record-comment-info {
        flex-direction: row-reverse;
      }

      .record-comment-content {
        margin-left: unset;
        margin-right: 8px;
        background-color: $--app-info-color;

        &::before {
          left: unset;
          right: -8px;
        }

        &::after {
          right: -6px;
          left: unset;
          border-top-color: $--app-info-color;
        }
      }
    }
  }
</style>

<style lang="scss">
  .record-single-comment {
    .record-comment-container {
      .record-comment-content {
        .record-comment-text {
          font-size: 14px;
          color: $--app-base-font-color;
          line-height: 1.7;

          .editor-comment-mention {
            color: $--app-primary-color;
          }
        }
      }
    }

    .record-comment-avatar {
      position: relative;
      .default-avatar {
        span{
          font-size: 0.5rem;
        }
      }
      .record-commentator-name {
        position: absolute;
        left: 32px;
        top: 5px;
        color: $--app-base-font-color;
        z-index: 10;
      }

      .single-record-commentator {
        width: 22px;
        height: 22px;
      }
    }
  }
</style>
